import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { getCountryRegion } from '@/utils/countryRegion';
import { efFetch, isReadyLang } from '@/utils';

const readyLangsFullSite = JSON.parse(process.env.NEXT_PUBLIC_READY_LANG_FULL_SITE || '[]');

const withLocaleRedirect = (WrappedComponent: any) => {
    const LocaleRedirect = (props: any) => {
        const router = useRouter();
        const { locale }: any = router;

        useEffect(() => {
            const redirectIfNeeded = async () => {
                const windowPath = window.location.pathname;

                const shouldRedirect = !windowPath.startsWith(`/${locale}`);

                if (shouldRedirect) {
                    const apiUrl = getCountryRegion(locale) === 'eu' ? process.env.NEXT_PUBLIC_LOGIN_HOST_EU : process.env.NEXT_PUBLIC_LOGIN_HOST;
                    const GEO_IP_API = `${apiUrl}/website/address/finGeoByIp`;
                    const COUNTRY_API = `${apiUrl}/general/location-api/countriesGroupByKey`;
                    try {
                        const res = await efFetch(GEO_IP_API);
                        let countryCode = res.data?.countryCode?.toLowerCase() || 'us';

                        // Map country codes as needed
                        const COUNTRY_CODE_MAP = {
                            ...readyLangsFullSite.reduce((acc: any, lang: any) => ({ ...acc, [lang]: lang }), {}),
                            gb: 'uk',
                            ru: 'cis',
                            sa: 'me-ar',
                        };
                        if (COUNTRY_CODE_MAP[countryCode]) {
                            countryCode = COUNTRY_CODE_MAP[countryCode];
                        } else {
                            // 获取国家列表及匹配对应CountryCode的数据中心地址(eu/us)
                            let countryListData = [];
                            try {
                                const { data = [] } = await efFetch(COUNTRY_API);
                                countryListData = data;
                            } catch (err) {}
                            countryListData = countryListData.reduce((acc: any, current: any) => [...acc, ...current.countryResponses], []);
                            const { dataCenterCode = 'us' } = countryListData.find((v: any) => v.countryCode === countryCode.toUpperCase());
                            // TODO: 后端预留其余多站点，但现版本仅考虑us和eu
                            countryCode = dataCenterCode === 'us' ? 'us' : 'eu';
                        }
                        // countryCode = COUNTRY_CODE_MAP[countryCode] || countryCode;

                        if (!isReadyLang(countryCode)) {
                            countryCode = 'us';
                        }
                        if (countryCode !== locale) {
                            window.location.href = `/${countryCode}${windowPath}`;
                        }
                    } catch {
                        window.location.href = `/us${windowPath}`;
                    }
                }
            };

            redirectIfNeeded();
        }, [locale, router]);

        return <WrappedComponent {...props} />;
    };

    return LocaleRedirect;
};

export default withLocaleRedirect;
